import React, { useState, useMemo } from "react"
import UniversalLink from "§/src/utils/UniversalLink"
import { isEmpty } from "lodash"
import "./_style.scss"

// Atoms
import TileContent from "§/src/components/atoms/content/tile-content"
import ButtonArrow from "§/src/components/atoms/buttons/button-arrow"
import Modal from "§/src/components/atoms/content/modal"

// Assets
import PatternDashed from "§/src/images/svg/pattern-dashed.svg"
import Clock from "§/src/images/svg/clock.svg"

// Functions
import { configuratorLink } from "§/src/utils/configuratorLink";

// Language
import { useTranslation } from "react-i18next"

const SelectorSelection = props => {
  const { t } = useTranslation()
  const [iframeLink, setIframeLink] = useState("")
  const { titleTaxSelector, pretitleTaxSelector, linkRepeater, ...linkCards } =
    props.data
  const modalid = useMemo(() => "modal-" + Math.floor(Math.random() * 9999), [])

  // Configurator Link
  const siteLanguage = process.env.GATSBY_SITE_LANG
  const originalId = ''

  return !isEmpty(props.data) ? (
    <>
      <Modal modalid={modalid} className="iframeModal">
        <div className="ratio mt-4 mb-4">
          <iframe title="Gefran Selectors" className="embed-responsive-item" src={iframeLink}></iframe>
        </div>
      </Modal>
      <div comp="selector-selection" className="row pb-5">
        <div className="selection-card tile-content temp-light-blue temp-pattern col-md-8">
          <div className="card h-100">
            <div className="card-body">
              <span className="card-pretitle fs-9 text-uppercase mb-2">
                {pretitleTaxSelector}
              </span>
              <h5 className="card-title h3">{titleTaxSelector}</h5>

              {linkRepeater && (
                <div className="link-group d-none d-md-flex">
                  {linkRepeater.map((linkElement, linkIndex) => {
                    return (
                      <button
                        key={linkIndex}
                        data-bs-toggle="modal"
                        className="btn btn-light t-tax"
                        data-bs-target={`#${modalid}`}
                        onClick={() => setIframeLink(configuratorLink(linkElement.link[1], siteLanguage, originalId))}
                        onMouseEnter={() => setIframeLink(configuratorLink(linkElement.link[1], siteLanguage, originalId))}
                      >
                        {linkElement.link[2]}
                      </button>
                    )
                  })}
                </div>
              )}

              {linkRepeater && (
                <div className="btn-group dropdown d-md-none mt-4">
                  <button
                    type="button"
                    className="btn btn-light dropdown-toggle text-wrap"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {t("Seleziona la categoria di prodotto")}
                  </button>

                  <ul className="dropdown-menu">
                    {linkRepeater.map((linkElement, linkIndexMob) => {
                      return (
                        <li
                          key={linkIndexMob}
                          data-bs-toggle="modal"
                          data-bs-target={`#${modalid}`}
                          className="dropdown-item"
                          onMouseEnter={() => setIframeLink(configuratorLink(linkElement.link[1], siteLanguage, originalId))}
                          onClick={() => setIframeLink(configuratorLink(linkElement.link[1], siteLanguage, originalId))}
                        >
                          {linkElement.link[2]}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>

        {linkCards && <TileContent data={linkCards} className="col-md-4" />}
      </div>
    </>
  ) : (
    ""
  )
}

export default SelectorSelection
